// Definiujemy interfejs dla propów
interface PersonProps {
    image_path: string;
    fullname: string;
    specjalnosci: string[];
    discord: string;
    linkedin_url: string | null;
    site_url: string | null;
    cite: string;
}


const PersonComponent = (
    { image_path, fullname, specjalnosci, discord, linkedin_url, site_url, cite }: PersonProps
) => (
    // Główny kontener centrujący zawartość i dodający padding pionowy
    <div className="flex flex-col items-center py-8">

        {/* Kontener ograniczający maksymalną szerokość i centrujący (zamiast w-1/2) */}
        <div className="w-full max-w-screen-xl mx-auto px-4">


            <div className="p-5 w-3/4 grid grid-cols-1 gap-8 screenbrake:grid-cols-2 screenbrake:gap-12 items-center m-auto">

                {/* Obraz */}

                <img
                    alt="Jakub Krawczyk foto"
                    className="rounded-2xl sm:w-5/8  md:w-1/2 lg:3/4 screenbrake:w-full opacity-90 bg-orange-900 bg-clip-content object-cover screenbrake:max-w-xs mx-auto"
                    src={image_path}
                />

                {/* Kontener z tekstem */}

                <div className="flex flex-col w-full gap-3 screenbrake:gap-4 items-center text-center">

                    <h2 className="text-2xl text-transparent font-black bg-gradient-to-r bg-clip-text from-orange-500 to-orange-700">
                        {fullname}
                    </h2>


                    <p className="text-lg">
                        {specjalnosci.map((specjalnosc, index) => (
                            <span key={index}>
                                {specjalnosc}
                                {index < specjalnosci.length - 1 && <br />}
                            </span>
                        ))}
                    </p>

                    <ul className="flex flex-col gap-2 pt-3">
                        {/* Element Discord */}
                        <li className="flex flex-row gap-5 items-center"> {/* Dodano items-center dla pionowego wyrównania */}
                            <span className="font-bold text-blue-500">
                                <img alt={"Discord logo"} src="discord.png" width="20" height="20"/>
                            </span>
                            {discord}
                        </li>

                        {/* Warunkowe renderowanie linku LinkedIn */}
                        {linkedin_url && (
                            <li className="flex flex-row gap-5 items-center"> {/* Dodano items-center */}
                                <span className="text-blue-400 font-bold">
                                    {/* Lepszy alt text */}
                                    <img alt={"LinkedIn logo"} src="linkedin.png" width="20" height="20"/>
                                </span>
                                <a target={"_blank"} href={linkedin_url} rel="noopener noreferrer">{fullname}</a> {/* Dodano rel="noopener noreferrer" dla bezpieczeństwa przy target="_blank" */}
                            </li>
                        )}

                        {/* Warunkowe renderowanie linku do strony (Site URL) */}
                        {site_url && (
                            <li className="flex flex-row gap-5 items-center"> {/* Dodano items-center */}
                                <span className="text-blue-400 font-bold">
                                    {/* Lepszy alt text */}
                                    <img alt={"Website icon"} src="web.svg" width="20" height="20"/>
                                </span>
                                <a target={"_blank"} href={site_url} rel="noopener noreferrer">{fullname}</a> {/* Dodano rel="noopener noreferrer" */}
                            </li>
                        )}

                        {/* Element Email (obecnie zakomentowany) */}
                        {/* <li><span className="font-bold text-orange-500">e-mail:</span> <a href="mailto:jakub.krawczyk1608@gmail.com">jakub.krawczyk1608@gmail.com</a> </li> */}
                    </ul>
                    <p className="pt-2 italic ">{cite}</p> {/* Używamy w-full na mobile, ograniczamy na desktopie */}
                </div>
            </div>
        </div>
    </div>
);

export default PersonComponent;